import { useEffect } from 'react'

export default function useController() {
  useEffect(() => {
    const previousTitle = document.title
    document.title = 'Privacy Policy | MagVenture Universe'
    window.scrollTo(0, 0)

    return () => {
      document.title = previousTitle
    }
  }, [])
}
